<div class="mbuilder-main-container" >
    <ng-container *ngIf="!spinner">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb builder-breadcrumb">
            <li (click)="onClickBreadcrumbUpdate('home')" class="breadcrumb-item inactive">Home</li>
            <li (click)="onClickBreadcrumbUpdate('projId')" class="breadcrumb-item inactive">
                {{this.breadcrumbData?.projectName | titlecase}}
            </li>
            <li class="breadcrumb-item active">{{this.breadcrumbData?.mobileApplicationName }}</li>
        </ol>
    </nav>

    <div class="mbuilder-body" cdkDropListGroup>
        <div class="mbuilder-sidenav">
            <lib-sidenav [selectedSection]="currentActiveContent"></lib-sidenav>
            <div class="mbuilder-sidenav-options">
                <div class="option" *ngIf="displaySidenavContent &&  ![sideNavOptions.publish,sideNavOptions.policy,sideNavOptions.media].includes(currentActiveContent)" @sidenavFadInOut>
                    <div class="option-item" [ngClass]="{'custom-width': isWidthApplied}">
                        <lib-sidenav-content [selectedOption]="currentActiveContent"></lib-sidenav-content>
                    </div>
                    <div class="option" *ngIf="displaySidenavContentList" @sidenavFadInOut>
                        <div class="option-item">
                            <lib-sidenav-content-list #sideNav [filteredCategories]="todo"
                                (onDrop)="moveItemToDone($event)"></lib-sidenav-content-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="publish-app option-item" *ngIf="displaySidenavContent && currentActiveContent === sideNavOptions.publish" @sidenavFadOutIn>
            <lib-publish-app></lib-publish-app>
        </div>
        
        <div class="policy-canvas"  *ngIf="displaySidenavContent && currentActiveContent === sideNavOptions.policy"      [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }">
            <lib-privacy-policy></lib-privacy-policy>
        </div>
        @if([appPermissions.viewPages,permissionsActions.read] | builderPermissions){
            <div class="mbuilder-canvas"  (click)="onCanvasClick($event)" *ngIf="!apiTab && !spinner && ![sideNavOptions.policy,sideNavOptions.dataDownload,sideNavOptions.media].includes(currentActiveContent)">
                <lib-mobile-screen  class="mobile-view" #mobileScreen (click)="onComponentClick($event)"
                    (onDrop1)="moveItemToTodo($event)"></lib-mobile-screen>
            </div>
        }
        <div class="meditor-canvas m-4"  *ngIf="displaySidenavContent && currentActiveContent === sideNavOptions.dataDownload" [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }" >
            <lib-entity-entries-table></lib-entity-entries-table>
        </div>
        <div class="mapi-canvas" *ngIf="apiTab"
            [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }">
            <lib-apiconfig></lib-apiconfig>
        </div>

        <div class="media-canvas"  *ngIf="displaySidenavContent && currentActiveContent === sideNavOptions.media"      [ngClass]="{ 'mbuilder-level-one': displaySidenavContent, 'mbuilder-level-two': displaySidenavContentList && displaySidenavContent }">
           <lib-media></lib-media>
        </div>


    </div>
    </ng-container>
    <vl-spinner id="application" [show]="spinner"></vl-spinner>

</div>